import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var CrmLongIcon = function CrmLongIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 97 36' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '97' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '36' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: height,
      viewBox: viewBox,
      width: width,
      xmlSpace: "preserve",
      x: "0px",
      y: "0px"
    },
    /*#__PURE__*/
    React.createElement("g", null,
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M5.68 4.93c.79-.44 1.657-.681 2.525-.681.79 0 1.539.2 2.17.561.67.36 1.302.882 1.854 1.443l.079.08 1.775-1.884-.04-.08c-.315-.48-.788-.962-1.38-1.403-.592-.44-1.262-.801-2.012-1.042-.75-.28-1.578-.4-2.485-.4-1.065 0-2.09.2-3.038.64-.946.401-1.814 1.003-2.564 1.764-.75.762-1.341 1.644-1.736 2.646C.394 7.576.198 8.698.198 9.9c0 1.684.354 3.207 1.025 4.45.67 1.282 1.617 2.244 2.761 2.966 1.144.681 2.486 1.042 3.945 1.042.829 0 1.657-.12 2.407-.32.749-.201 1.42-.522 1.972-.843.592-.36 1.026-.721 1.38-1.082l.119-.08-1.341-2.245-.08.08c-.394.441-.946.802-1.617 1.163-.67.36-1.46.52-2.327.52-.947 0-1.854-.2-2.683-.64-.828-.401-1.499-1.043-1.972-1.884-.513-.842-.75-1.925-.75-3.207 0-1.163.237-2.165.75-3.007.434-.801 1.105-1.443 1.894-1.884zM27.575 9.7c.591-.841.867-1.803.867-2.765 0-1.083-.236-2.045-.75-2.806-.512-.802-1.143-1.403-1.932-1.804-.79-.441-1.617-.641-2.446-.641h-6.903v16.474h2.682v-6.133h3.472l3.353 6.053.04.04 3.234.04-3.748-6.573c.829-.441 1.578-1.043 2.13-1.884zM25.72 6.896c0 .64-.197 1.202-.591 1.723-.395.521-.908.762-1.618.762h-4.457V4.29h3.826c.79 0 1.46.24 2.012.72.552.442.828 1.083.828 1.885zM39.449 10.222L34.28 1.643h-2.604v16.475h2.683v-6.774c0-.962 0-1.884-.04-2.766-.04-.721-.079-1.443-.158-2.164l4.34 6.974.04.04h1.617l4.497-7.055c-.08.722-.119 1.444-.158 2.165-.04.882-.04 1.804-.04 2.766v6.774h2.683V1.643h-2.446l-5.246 8.579zM53.65.08L52.901 1.323 52.151.08 51.717.08 51.717 2.325 52.23 2.325 52.23 1.042 52.703 1.844 53.098 1.844 53.611.962 53.611 2.325 54.123 2.325 54.123.08zM49.705.521L50.297.521 50.297 2.325 50.77 2.325 50.77.521 51.401.521 51.401.08 49.705.08z",
      transform: "translate(-680 -430) translate(640 314) translate(40 116) translate(42.146 7.902)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls2,
      d: "M30.72 5.273c-7.038-7.03-18.441-7.03-25.44 0-7.04 7.031-7.04 18.423 0 25.454 7.038 7.03 18.441 7.03 25.44 0 7.04-7.031 7.04-18.423 0-25.454z",
      transform: "translate(-680 -430) translate(640 314) translate(40 116)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls3,
      d: "M14.927 18.439c0 2.425 2.837 4.39 6.375 4.39h7.502c.583-1.338.972-2.843 1.05-4.39H14.927zM22.509 28.098c1.85-.78 3.449-1.995 4.71-3.513h-7.024c0 1.388 1.052 2.645 2.314 3.513zM15.274 15.805h14.58c-.2-1.589-.678-3.052-1.395-4.39H8.78c0 2.383 2.909 4.39 6.494 4.39z",
      transform: "translate(-680 -430) translate(640 314) translate(40 116)"
    })))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.common.mediumGray
      };
    },
    cls2: function cls2() {
      return {
        fill: theme.palette.product.crm,
        fillRule: 'evenodd'
      };
    },
    cls3: {
      fill: theme.palette.common.white
    }
  };
});